import React from 'react';

const RefundPolicy = () => (
  <main className="bg-white min-h-screen py-12">
    <div className="container mx-auto px-4 max-w-3xl">
      <h1 className="text-3xl md:text-4xl font-bold mb-6 text-primary">Refund Policy</h1>
      <p className="text-dark leading-relaxed mb-4">
        <strong>No Refunds for Donations:</strong> Once a donation is made, it is considered final and non-refundable. If you believe an error occurred during your donation, please contact us immediately at{' '}
        <a href="mailto:jivadayamandalbhachau@yahoo.com" className="text-blue-500 underline">jivadayamandalbhachau@yahoo.com</a> or{' '}
        <a href="tel:+919925042930" className="text-blue-500 underline">+91 99250 42930</a>. We will review your case, but generally, donations are not refunded.
      </p>
      <h2 className="text-2xl font-bold mb-2 mt-8 text-primary">Contact</h2>
      <p className="text-dark leading-relaxed">
        For any questions or concerns about this Refund Policy, please contact us at <a href="mailto:jivadayamandalbhachau@yahoo.com" className="text-blue-500 underline">jivadayamandalbhachau@yahoo.com</a>.
      </p>
    </div>
  </main>
);

export default RefundPolicy;
